import React from "react"
import ExcelJS from "exceljs"
import { saveAs } from "file-saver"
import { PERFORMANCE_CHARACTERISTIC_LEGEND } from "../../../constant/Constants";

function ExportToExcelCategories(props) {
   const fullData = props.data
   const columnData = props.columnData
   const keysInObject = props.keysInObject
   let keysSecondType = props.keysSecondType
   let keysThirdType = props.keysThirdType
   let keysNotUsed = props.keysNotUsed
   let partName = props.partName
   const getFlattenedData = (data, keys) => {
      if (!data || !Array.isArray(data)) {
         console.error("Invalid data passed to getFlattenedData:", data)
         return []
      }

      return data.map((record) => {
         const baseRecord = {}
         let highlightRow = false // Flag to determine if the row should be highlighted

         // Create the base record with all key-value pairs
         keys.forEach((key) => {
            if (Array.isArray(record[key])) {
                let data=""
                for (let i=0;i<record[key].length;i++){
                  data =data+`${i} :${record[key][i]}`
                     if(i<record[key].length-1){
                        data =data+","
                     }
                   baseRecord[key] = data
                  }
            } else {
               baseRecord[key] = record[key] || ""
            }
         })

         // Dynamically check if two specific keys have different values
         const key1 = keys[1] // First key to compare
         const key2 = keys[2] // Second key to compare

         if (record[key1] !== record[key2]) {
            highlightRow = true // Mark the row for highlighting
         }

         // Add a custom property to indicate if the row should be highlighted
         baseRecord.Highlight = highlightRow ? "Yes" : "No"

         return { ...baseRecord, highlightRow }
      })
   }
   
   const COMPAREKeys = {
      attributes: "Attributes",
      weightCharacteristic: "Weight Characteristic",
      storageTransportData: "Storage, Transport, Labeling",
      notes: "Notes",
      marketClearance: "Market Clearance",
      billofMaterials: "Bill Of Materials",
      subStitutes: "Substitutes",
      relatedSpecifications: "Related Specifications",
      masterSpecifications: "Master Specifications",
      referenceDocuments: "Reference Documents",
      performanceCharacteristic: "Performance Characteristic",
      lifecycleApprovalPowerview: "Lifecycle Approval Powerview",
      ownership: "Ownership",
      ipClasses: "IP Classes",
      securityClasses: "Security Classes",
      relatedats: "Related ATS",
      rohPlants: "Plants",
      organizations: "Organizations",
      files: "Files",
      derivedParts: "Related Parts",
      // derivedTo:"Derived To" ,
      // derivedFrom:"DerivedFrom" ,
      certification: "Certifications",
      sustainability: "Sustainability",
      gpsAssessment: "GPS Assessments",
      materialsAndComposition: "Materials & Composition",
      rdsites: "R&D Sites",
      producingformula: "Producing Formula",
      alternates: "Alternates",
      batteryDetails: "Battery Details",
      chemicalMolecularProperties: "Chemical Molecular Properties",
      chemicalClassification: "Chemical Classification",
      detergentSurfactantProperties: "Detergent Surfactant Properties",
      pqrSupplierView: "PQR View-SE",
      pqrViewManufacturer: "PQR View-ME",
      startingmaterials: "Starting Materials",
      security: "Security Classes",
      stabilityDocument: "Stability Document",
      packagingCertificationsMaster: "Packaging Certifications",
      ownership: "Ownership",
      organizationsObject: "Organizations",
      profileIdentification: "Profile Identification",
      perfumeProperties: "Perfume Properties",
      halbPlants: "Plants",
      physicalProperties: "Physical Properties",
      certificationsMaster: "Certifications",
      plants: "Plants",
      substitution: 'Substitutes',
      registrationDetails: "Registration Details",
      billOfMaterials: "Bill Of Materials",
      notes: "Notes",
      sapBomasFed: "SAP BOM as Fed",
      marketOfSale: "Market of Sale",
      weightsDimensionsObject: "Weights & Dimensions",
      cupArtworks: "CUP Artworks",
      batteryCalculation:  "Battery Calculation",
      billOfMaterialsCustomerUnit: "BOM-CUP",
      substitutesConsumerUnit: "Substitutes-COP",
      substitutesMasterConsUnit:"Substitutes-MCOP",
      bomMasterCunsumerUnit: "BOM-MCOP",
      bomInnerPack: "BOM-MIP",
      baseCodeDetails: "Base Code Details",
      transportUnit: "Transport Unit",
      packingUnit: "Packing Unit",
      bomTransportUnit: "BOM-Transport Unit",
      substitutesInnerPack: "Substitutes Inner Pack",
      // storageTransportData: "Storage, Transportation, Labeling Assessment Data",
      batteryRollUp: "Battery Roll-Up",
      substitutes: "Substitutes",
      substitutesCustomerUnit: "Substitutes Customer Unit",
      substitutesTransportUnit: "Substitutes Transport Unit",
      bomMasterCustmerUnit: "BOM-MCUP",
      bomMasterInnerPack: "BOM-MIP",
      substitutesMasterInnerPack:"Substitutes-MIP",
      substitutesMasterConsumerUnit: "Substitutes-MCOP",
      bomConsumerUnit: "BOM-COP",
      substitutesMastesConsumerUnit: "Substitutes-MCUP",
      relatedACS: "Related ACS",
      relatedIAPS: "Related IAPS",
      marketClearance: "Market Clearance",
      relatedSoftwareBuilds: "Related Software Builds",
      whereUsed: "Where Used",
   }

   const exportToExcel = async () => {
      const workbook = new ExcelJS.Workbook()
      workbook.creator = "Your App"
      workbook.created = new Date()

      // Iterate over each category in columnData

      columnData.forEach(({ category, columnData }, index) => {
         let categoryName = COMPAREKeys[category]

         const worksheet = workbook.addWorksheet(`${categoryName}`)

         if (!keysSecondType.includes(category) && !keysThirdType.includes(category)) {
            const keys = keysInObject[index].filter((key) => key !== "Highlight") // Exclude "Highlight" from keys
            const dataForCategory = fullData.find((item) => item[category])[category] // Get data for the current category
            if (!dataForCategory) {
               console.warn(`No data found for category "${category}". Skipping...`)
               return
            }
            const flattenedData = getFlattenedData(dataForCategory, keys)

            // Create a worksheet for the category

            // Add headers (exclude "Highlight")
            const filteredColumnData = columnData.filter(
               (col) => col.value !== "Highlight"
            )

            const excelRow = worksheet.addRow(filteredColumnData.map((col) => col.label))
            excelRow.eachCell((cell) => {
               cell.font = { bold: true, color: "FFFFFF" }
               cell.fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "0099FF" }, // Red background
               }
               cell.border = {
                  top: { style: "thin" },
                  left: { style: "thin" },
                  bottom: { style: "thin" },
                  right: { style: "thin" },
               }
               cell.alignment = {
                  width: 30,
               }
            })

            filteredColumnData.forEach((col, index) => {
               worksheet.getColumn(index + 1).width = 30 // Set column width to 30 characters
            })

            // Add data rows
            flattenedData.forEach((row) => {
               const excelRow = worksheet.addRow(
                  filteredColumnData.map((col) => row[col.value] || "")
               )

               // Apply red background color if highlightRow is true
               if (row.highlightRow) {
                  excelRow.eachCell((cell) => {
                     cell.fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "FFCCCC" }, // Red background color
                     }
                     cell.font = {
                        color: { argb: "FF0000" }, // White text color for better contrast
                     }
                     cell.border = {
                        top: { style: "thin" },
                        left: { style: "thin" },
                        bottom: { style: "thin" },
                        right: { style: "thin" },
                     }
                     cell.alignment = {
                        width: 30,
                     }
                  })
               } else {
                  excelRow.eachCell((cell) => {
                     cell.fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "FFFFFF" }, // Red background color
                     }
                     cell.font = {
                        color: { argb: "000000" }, // White text color for better contrast
                     }
                     cell.border = {
                        top: { style: "thin" },
                        left: { style: "thin" },
                        bottom: { style: "thin" },
                        right: { style: "thin" },
                     }
                     cell.alignment = {
                        width: 30,
                     }
                  })
               }
            })
         } else if (
            keysSecondType.includes(category) ||
            keysThirdType.includes(category)
         ) {
            const keys = keysInObject[index].filter((key) => key !== "Highlight") // Exclude "Highlight" from keys

            // Check if fullData and rdsites exist
            let categoryData = `${category}data`
            categoryData = fullData.find((item) => item[category])?.[category]
            if (!fullData || !categoryData) {
               console.warn("Invalid or missing fullData or rdsites data:", fullData)
               return
            }
            let releaseHeader
            let releaseHeaderData
            let releaseDateAndTimeOfLastMOS
            let releaseDateAndTimeOfLastMOSData

            if (category === "packagingCertificationsMaster") {
               releaseHeader = categoryData["releaseHeader"]
               for (const property in releaseHeader) {
                  releaseHeaderData = `${property}: ${releaseHeader[property]}`
               }
            }
             if (category === "marketOfSale") {
               releaseDateAndTimeOfLastMOS = categoryData["releaseDateAndTimeOfLastMOS"]
               for (const property in releaseDateAndTimeOfLastMOS) {
                  releaseDateAndTimeOfLastMOSData = `${property}: ${releaseDateAndTimeOfLastMOS[property]}`
               }
            }
            if (category === "packagingCertificationsMaster") {
               worksheet.getCell(
                  1,
                  1
               ).value = `Revision :${props.revision["releaseRevision"]} ${COMPAREKeys[category]}`
               worksheet.getCell(2, 1).value = `${releaseHeaderData}`
               worksheet.getCell(1, 1).font = { bold: true, color: "000000" }
               worksheet.getCell(1, 1).fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "EEEEEE" },
               }
            } 
             else  if (category === "marketOfSale") {
               worksheet.getCell(
                  1,
                  1
               ).value = `Revision :${props.revision["releaseRevision"]} ${COMPAREKeys[category]}`
               worksheet.getCell(2, 1).value = `${releaseDateAndTimeOfLastMOSData}`
               worksheet.getCell(3, 1).value = "Please note that changes which have occurred after this calculation Date and Time are NOT reflected in the table below"
               worksheet.getCell(1, 1).font = {
                  bold: true,
                  color: "000000",
               }
               worksheet.getCell(1, 1).fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "EEEEEE" },
               }
            } 
            else {
               worksheet.getCell(1, 1).value =
                  "Revision :" +
                  " " +
                  `${props.revision["releaseRevision"]}` +
                  " " +
                  `${COMPAREKeys[category]}`
               const cell = worksheet.getCell(1, 1)
               cell.font = { bold: true, color: "000000" }
               cell.fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "EEEEEE" }, // Red background
               }
            }
            // worksheet.getCell(1, 1).value = `release-${props.revision["releaseRevision"]}`;

            let keys1 = []
            for (let i = 0; i < keys.length; i++) {
               if (
                  keys[i] !== "id" &&
                  keys[i] !== "link" &&
                  keys[i] !== "refId" &&
                  keys[i] !== "methodId" &&
                  keys[i] !== "refLink" &&
                  keys[i] !== "parentName" &&
                  keys[i] !== "names" &&
                  keys[i] !== "methodLink" &&
                  keys[i] !== "isIRM" &&
                  keys[i] !== "filepath" &&
                  // keys[i] !== "Title" &&
                  // keys[i] !== "Format" &&
                  keys[i] !== "File Name" &&
                  keys[i] !== "ZcsURL" &&
                  keys[i] !== "zcsurl" &&
                  keys[i] !== "Action"
               ) {
                  keys1.push(keys[i])
               }
            }
            keys1.forEach((key, index) => {
               const cell = worksheet.getCell(
                  category === "marketOfSale" ? 4 :(category === "packagingCertificationsMaster" ? 3 :2),
                  index + 1
               )
               cell.value = key
               cell.font = { bold: true, color: "FFFFFF" }
               cell.fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "0099FF" }, // Red background
               }
               cell.border = {
                  top: { style: "thin" },
                  left: { style: "thin" },
                  bottom: { style: "thin" },
                  right: { style: "thin" },
               }
               cell.alignment = {
                  wrapText: true,
                  width: 20,
               }
            })
            let obsoleteHeader
            let obsoleteHeaderData
            let obsoleteDateAndTimeOfLastMOS
            let obsoleteDateAndTimeOfLastMOSData

            if (category === "packagingCertificationsMaster") {
               obsoleteHeader = categoryData["obsoleteHeader"]
               for (const property in obsoleteHeader) {
                  obsoleteHeaderData = `${property}: ${obsoleteHeader[property]}`
               }
            }
             if (category === "marketOfSale") {
               obsoleteDateAndTimeOfLastMOS = categoryData["obsoleteDateAndTimeOfLastMOS"]
               for (const property in obsoleteDateAndTimeOfLastMOS) {
                  obsoleteDateAndTimeOfLastMOSData = `${property}: ${obsoleteDateAndTimeOfLastMOS[property]}`
               }
            }

            if (category === "packagingCertificationsMaster") {
               worksheet.getCell(
                  1,
                  keys1.length + 3
               ).value = `Revision :${props.revision["obsoleteRevision"]} ${COMPAREKeys[category]}`
               worksheet.getCell(2, keys1.length + 3).value = `${obsoleteHeaderData}`
               worksheet.getCell(1, keys1.length + 3).font = {
                  bold: true,
                  color: "000000",
               }
               worksheet.getCell(1, keys1.length + 3).fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "EEEEEE" },
               }
            } else  if (category === "marketOfSale") {
               worksheet.getCell(
                  1,
                  keys1.length + 3
               ).value = `Revision :${props.revision["obsoleteRevision"]} ${COMPAREKeys[category]}`
               worksheet.getCell(2, keys1.length + 3).value = `${obsoleteDateAndTimeOfLastMOSData}`
               worksheet.getCell(3,keys1.length + 3).value = "Please note that changes which have occurred after this calculation Date and Time are NOT reflected in the table below"
               worksheet.getCell(1, keys1.length + 3).font = {
                  bold: true,
                  color: "000000",
               }
               worksheet.getCell(1, keys1.length + 3).fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "EEEEEE" },
               }
            } 
            else {
               worksheet.getCell(1, keys1.length + 3).value =
                  category === "packagingCertificationsMaster"
                     ? `${obsoleteHeaderData} Revision :${props.revision["obsoleteRevision"]}`
                     : `Revision :${props.revision["obsoleteRevision"]} ${COMPAREKeys[category]}`

               worksheet.getCell(1, keys1.length + 3).font = {
                  bold: true,
                  color: "000000",
               }
               worksheet.getCell(1, keys1.length + 3).fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "EEEEEE" },
               }
            }

            keys1.forEach((key, index) => {
               const cell = worksheet.getCell(
                  category === "marketOfSale" ? 4 :(category === "packagingCertificationsMaster" ? 3 :2),
                  keys1.length + 3 + index
               )
               cell.value = key
               cell.font = { bold: true, color: "FFFFFF" }
               cell.fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "0099FF" }, // Red background
               }
               cell.border = {
                  top: { style: "thin" },
                  left: { style: "thin" },
                  bottom: { style: "thin" },
                  right: { style: "thin" },
               }
               cell.alignment = {
                  wrapText: true,
                  width: 20,
               }
            })
            // Set column widths for release and obsolete columns
            keys1.forEach((key, index) => {
               worksheet.getColumn(index + 1).width = 30 // Set width for release columns
            })
            keys1.forEach((key, index) => {
               worksheet.getColumn(keys1.length + 3 + index).width = 30 // Set width for obsolete columns
            })

            // Determine the maximum number of rows between release and obsolete
            const maxRows = Math.max(
               categoryData.release ? categoryData.release.length : 0,
               categoryData.obsolete ? categoryData.obsolete.length : 0
            )

            let i = keys.indexOf("Short Code")

            for (let i = 0; i < maxRows; i++) {
               let data1 = []
               if (categoryData.release[i]) {
                  for (let j = 0; j < keys1.length; j++) {
                     if (categoryData.release[i]) {
                        if (typeof categoryData.release[i][[keys1[j]]] === "object") {
                           let dataCategory = ""
                           let keyValue
                           for (const property in categoryData.release[i][[keys1[j]]]) {
                              if (
                                 property !== "id" &&
                                 property !== "link" &&
                                 property !== "refId" &&
                                 property !== "parentName" &&
                                 property !== "names" &&
                                 property !== "methodId" &&
                                 property !== "refLink" &&
                                 property !== "methodLink"
                              ) 
                              {
                                 let keyValueInObject = ""
                                 if(typeof(categoryData.release[i][[keys1[j]]][property]) === "object"){
                                    
                                    for (const values in categoryData.release[i][[keys1[j]]][property]){
                                       if(
                                          values !== "id" &&
                                          values !== "link" &&
                                          values !== "refId" &&
                                          values !== "parentName" &&
                                          values !== "names" &&
                                          values !== "methodId" &&
                                          values !== "refLink" &&
                                          values !== "methodLink"
                                       )
                                          {
                                             keyValueInObject = categoryData.release[i][[keys1[j]]][property][values]
                                             keyValueInObject = `${keyValueInObject}`
                                          }
                                       }
                                    }
                                    else{
                                       keyValueInObject = categoryData.release[i][[keys1[j]]][property]
                                          ? categoryData.release[i][[keys1[j]]][property]
                                          : ""
                                    }
                                 keyValue = keyValueInObject
                                 dataCategory += `${property}: ${keyValue}` + "\n"
                              }
                           }
                           data1.push(dataCategory)
                        } else {
                           data1.push(categoryData.release[i][[keys1[j]]])
                        }
                     } else {
                        data1.push("")
                     }
                  }
               }

               const releaseRow = data1

               let data2 = []

               for (let j = 0; j < keys1.length; j++) {
                  if (categoryData.obsolete[i]) {
                     if (typeof categoryData.obsolete[i][[keys1[j]]] === "object") {
                        let dataCategory = ""
                        let keyValue
                        for (const property in categoryData.obsolete[i][[keys1[j]]]) {
                           if (
                              property !== "id" &&
                              property !== "link" &&
                              property !== "refId" &&
                              property !== "parentName" &&
                              property !== "names" &&
                              property !== "methodId" &&
                              property !== "refLink" &&
                              property !== "methodLink"
                           ) 
                           {
                              let keyValueInObject = ""
                                 if(typeof(categoryData.obsolete[i][[keys1[j]]][property]) === "object"){
                                    
                                    for (const values in categoryData.obsolete[i][[keys1[j]]][property]){
                                       if(
                                          values !== "id" &&
                                          values !== "link" &&
                                          values !== "refId" &&
                                          values !== "parentName" &&
                                          values !== "names" &&
                                          values !== "methodId" &&
                                          values !== "refLink" &&
                                          values !== "methodLink"
                                       )
                                          {
                                             keyValueInObject = categoryData.obsolete[i][[keys1[j]]][property][values]
                                             keyValueInObject = `${keyValueInObject}`
                                          }
                                       }
                                    }
                                    else{
                                       keyValueInObject = categoryData.obsolete[i][[keys1[j]]][property]
                                          ? categoryData.obsolete[i][[keys1[j]]][property]
                                          : ""
                                    }
                                 keyValue = keyValueInObject
                                 dataCategory += `${property}: ${keyValue}` + "\n"
                           }
                        }
                        data2.push(dataCategory)
                     } else {
                        data2.push(categoryData.obsolete[i][[keys1[j]]])
                     }
                  } else {
                     data2.push("")
                  }
               }

               const obsoleteRow = data2
               const combinedRow = worksheet.addRow([
                  ...releaseRow,
                  "",
                  "",
                  ...obsoleteRow,
               ])
               combinedRow.eachCell((cell) => {
                  cell.border = {
                     top: { style: "thin" },
                     left: { style: "thin" },
                     bottom: { style: "thin" },
                     right: { style: "thin" },
                  }
                  cell.alignment = {
                     wrapText: true,
                     width: 20,
                  }
               })
               const isDifferent = releaseRow.some(
                  (value, index) => value !== obsoleteRow[index]
               )
               if (isDifferent) {
                  for (let i = 0; i < releaseRow.length; i++) {
                     if (releaseRow[i] !== obsoleteRow[i]) {
                         const releaseCellAddress = worksheet.getCell(combinedRow.number, i + 1); 
                         const obsoleteCellAddress = worksheet.getCell(combinedRow.number, releaseRow.length + 3 + i); 
                         releaseCellAddress.fill = {
                              type: "pattern",
                              pattern: "solid",
                              fgColor: { argb: "FFCCCC" }, 
                         };
                         releaseCellAddress.font = {
                             bold: true,
                             color: { argb: "FF0000" }, 
                         };
                         releaseCellAddress.border = {
                             top: { style: "thin" },
                             left: { style: "thin" },
                             bottom: { style: "thin" },
                             right: { style: "thin" },
                         };
                         obsoleteCellAddress.fill = {
                             type: "pattern",
                             pattern: "solid",
                             fgColor: { argb: "FFCCCC" }, 
                         };
                         obsoleteCellAddress.font = {
                             bold: true,
                             color: { argb: "FF0000" }, 
                         };
                         obsoleteCellAddress.border = {
                             top: { style: "thin" },
                             left: { style: "thin" },
                             bottom: { style: "thin" },
                             right: { style: "thin" },
                         };
                     }
                  }
                  combinedRow.eachCell((cell) => {
                     cell.fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "FFCCCC" }, 
                     }
                  })
               }
            }
            if (category === "performanceCharacteristic") {
      
               let startRow = (worksheet.lastRow ? worksheet.lastRow.number : 0) + 2; 
               worksheet.getCell(`A${startRow}`).value = "PC Legend";
               worksheet.getCell(`A${startRow}`).font = { bold: true };
                  worksheet.getCell(`A${startRow}`).fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "EEEEEE" },
               };
            PERFORMANCE_CHARACTERISTIC_LEGEND.forEach((row, i) => {
            worksheet.getCell(`A${startRow + 1 + i}`).value = row[0];
            worksheet.getCell(`B${startRow + 1 + i}`).value = row[1];
            });

            for (let i = 0; i <= PERFORMANCE_CHARACTERISTIC_LEGEND.length; i++) {
               worksheet.getCell(`A${startRow + i}`).border = {
                  top: { style: "thin" },
                  left: { style: "thin" },
                  bottom: { style: "thin" },
                  right: { style: "thin" },
               };
               worksheet.getCell(`B${startRow + i}`).border = {
                  top: { style: "thin" },
                  left: { style: "thin" },
                  bottom: { style: "thin" },
                  right: { style: "thin" },
               };
               worksheet.getCell(`A${startRow + i}`).alignment = { wrapText: true };
               worksheet.getCell(`B${startRow + i}`).alignment = { wrapText: true };
            }
               worksheet.getColumn(1).width = 25;
               worksheet.getColumn(2).width = 40;
            }
            if (category === "marketOfSale") {
               if (releaseDateAndTimeOfLastMOSData !== obsoleteDateAndTimeOfLastMOSData) {
                  worksheet.getCell(2, 1).fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "FFCCCC" },
                  };
                  worksheet.getCell(2, keys1.length + 3).fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "FFCCCC" },
                  };
                  worksheet.getCell(2, 1).font = { bold: true, color: { argb: "FF0000" } };
                  worksheet.getCell(2, keys1.length + 3).font = { bold: true, color: { argb: "FF0000" } };
               }
            }
         }
      })
      try {
         const buffer = await workbook.xlsx.writeBuffer()
         saveAs(new Blob([buffer]), `${partName}_PartCompare_Report.xlsx`)
      } catch (error) {
         console.error("Error generating Excel file:", error)
      }
   }

   return (
      <i
         className="fa fa-file-excel-o"
         onClick={exportToExcel}
         style={{ color: "green", fontSize: "30px", padding: "2px", cursor: "pointer" }}
      ></i>
   )
}

export default ExportToExcelCategories